<template>
    <div class="copyright" :class="variant">
        <div class="help"><a href="mailto:help@thepaymentoption.com"><i class="fas fa-user-headset mr-2"></i>Need some help? Contact Us.</a></div>
        <div class="mt-1 ml-1">&copy; {{year}} The Payment Option</div>
    </div>
</template>

<script>
    export default {
        name: "Copyright",
        props: ['variant'],
        data: function() {
            return {
                year: new Date().getFullYear()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .copyright {
        display: inline-block;
        margin: 0 auto;
        color: rgba(255, 255, 255, 0.5);
        font-size: 0.9rem;
        border-radius: 0.3rem;
        padding: 0.2rem;

        &.dark {
            background: none !important;
            color: #999;

            .help, .help a {
                color: white;
            }
        }

        .help, .help a {
            color: #3c3c5f;
            display: inline-block;
        }
    }
</style>
